<template>
  <article class="order_tacker_container">
    <h3 class="wow fadeInUp">{{ title }}</h3>
    <section class="content">
      <section class="img-container wow bounceIn">
        <img :src="getImgUrl(img)" loading="lazy" draggable="false" />
      </section>
      <section class="text-wrapper wow fadeInUp">
        <p>{{ description }}</p>
        <article>
          <span v-for="(spec, index) in spacifications" :key="index">
            <i class="far fa-check-circle"></i>
            {{ spec }}
          </span>
        </article>
      </section>
    </section>
  </article>
</template>

<script>
import { getImgUrl } from "@/util/methods";
export default {
  name: "OrderTacker",
  props: ["title", "description", "img", "spacifications"],
  methods: {
    getImgUrl,
  },
};
</script>

<style></style>
